import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { MarketingFundCreateInput } from "@colab/shared";

// POST /api/admin/mdf/funds
//
// Replaces /app/admin/mdf/_actions.ts::createFundAction. Pessimistic: a new
// fund is low-frequency and the redirect-to-detail UX in Phase 7 is driven
// off the returned id, so optimism would add complexity without value.
// Sub-bucket 15 — also invalidates admin.dashboard() because the dashboard
// surfaces the open-fund count + aggregate budget widget; a new fund
// changes both immediately.
export function useCreateFund() {
  const queryClient = useQueryClient();
  return useMutation<{ id: string }, ApiClientError, MarketingFundCreateInput>({
    mutationFn: (input) =>
      apiFetch<{ id: string }>("/admin/mdf/funds", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.funds() });
      void queryClient.invalidateQueries({ queryKey: queryKeys.admin.dashboard() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to create fund");
    },
  });
}
